import { STATES_BY_SLUG } from "@/lib/generated/states";
import { toCitySlug } from "@shared/formats/city";

const FEATURED_PRODUCTS = ["pallets", "ibc-totes", "gaylord-boxes"];
const FEATURED_LOCATIONS = [
  "texas/houston",
  "california/los-angeles",
  "georgia/atlanta",
  "illinois/chicago",
  "texas",
  "california",
];

export function featuredGeoPaths(productSlug?: string | null) {
  const products = productSlug ? [productSlug] : FEATURED_PRODUCTS;
  return products.flatMap((product) =>
    FEATURED_LOCATIONS.map((location) => `/buy-${product}/${location}`),
  );
}

export function areaGeoPaths({
  productSlug,
  stateCode,
  location,
  intent,
}: {
  productSlug?: string | null;
  stateCode?: string | null;
  location?: { city?: string; state?: string } | null;
  intent?: string;
}) {
  if (intent === "recycle" || !productSlug) return [];
  const stateValue = (stateCode ?? location?.state)?.toLowerCase();
  const state = Object.values(STATES_BY_SLUG).find((entry) =>
    [entry.slug, entry.name.toLowerCase(), entry.code.toLowerCase()].includes(stateValue ?? ""),
  );
  if (!state) return [];
  const statePath = `/buy-${productSlug}/${state.slug}`;
  const locationState = location?.state?.toLowerCase();
  const matchesLocation = [state.slug, state.code.toLowerCase(), state.name.toLowerCase()]
    .includes(locationState ?? "");
  const citySlug = matchesLocation && location?.city ? toCitySlug(location.city) : undefined;
  return [...(citySlug ? [`${statePath}/${citySlug}`] : []), statePath];
}
